(function(){
  if (window.__spStep3TotalShipInit) return;
  window.__spStep3TotalShipInit = true;

  function findAtcWrap(section){
    var atcBtn = section.querySelector('#addToCart');
    if (!atcBtn) return null;
    return atcBtn.closest(
      '.product-form__cart-submit-wrapper, .product-single__add-to-cart-wrapper, ' +
      '.product__addon-add-to-cart, [class*="add-to-cart"]'
    ) || atcBtn;
  }

  function relocatePrice(section){
    var atcWrap = findAtcWrap(section);
    if (!atcWrap) return false;
    var priceBlock = section.querySelector('.product-single__price');
    if (priceBlock && priceBlock.dataset.spRelocated !== 'true'){
      atcWrap.parentNode.insertBefore(priceBlock, atcWrap);
      priceBlock.dataset.spRelocated = 'true';
    }
    return true;
  }

  function pickWishlistAddCta(section){
    // 2026-06-11: previously hunted the page for an app wishlist button and
    // fell back to grabbing the bare "/pages/wishlist" LINK — which navigated
    // instead of adding. Build a real sw-wishlist button instead: the global
    // sw-wishlist delegate (spx-sw-wishlist.js) handles any [data-sw-wl-btn]
    // carrying the standard data attributes (price in CENTS, matching the
    // collection-grid emitters).
    try {
      var meta = (window.meta && window.meta.product) ? window.meta.product : null;
      if (!meta || !meta.id) return null;
      var priceEl = section.querySelector('#productprice');
      var cents = priceEl ? parseInt(priceEl.getAttribute('data-price') || '0', 10) : 0;
      var og = document.querySelector('meta[property="og:image"]');
      var handle = (location.pathname.split('/products/')[1] || '').split('/')[0].split('?')[0];
      var titleEl = section.querySelector('.product-single__title');
      var vid = new URLSearchParams(location.search).get('variant')
                || (meta.variants && meta.variants[0] && meta.variants[0].id) || '';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rs-btn-option';
      btn.setAttribute('data-sw-wl-btn', '');
      btn.setAttribute('data-product-id', String(meta.id));
      btn.setAttribute('data-variant-id', String(vid));
      btn.setAttribute('data-product-title', titleEl ? titleEl.textContent.trim() : document.title);
      btn.setAttribute('data-product-price', String(cents));
      btn.setAttribute('data-product-image', og ? (og.getAttribute('content') || '') : '');
      btn.setAttribute('data-product-handle', handle);
      btn.setAttribute('data-product-type', String(meta.type || ''));
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="15" height="15" aria-hidden="true">' +
          '<path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>' +
        '</svg>' +
        '<span class="sp-cta-label">Add to Wishlist</span>';
      return btn;
    } catch (e) { return null; }
  }

  function buildSecondaryCtas(section){
    if (section.querySelector('.sp-secondary-ctas')) return true;
    var atcWrap = findAtcWrap(section);
    if (!atcWrap) return false;

    var sched    = section.querySelector(
      '.product__addon-schedule-appointment, [class*="schedule-appointment"]:not(.sp-secondary-ctas *)'
    );
    if (sched){
      // 2026-06-11: the legacy global click handler for this class targets a
      // popup that no longer exists (#website-video-appointment) — clicks died.
      // Strip the legacy class and point at the branded appointment modal
      // (sp-book-appt-popup, rendered globally, opens on [data-sp-appt-open]).
      sched.classList.remove('product__addon-schedule-appointment');
      sched.setAttribute('data-sp-appt-open', '');
      sched.setAttribute('href', 'javascript:void(0)');
    }
    var wishlist = pickWishlistAddCta(section);

    var picked = [sched, wishlist].filter(Boolean);
    if (!picked.length) return false;

    var grid = document.createElement('div');
    grid.className = 'sp-secondary-ctas';
    picked.forEach(function(el){ grid.appendChild(el); });

    if (atcWrap.nextSibling){
      atcWrap.parentNode.insertBefore(grid, atcWrap.nextSibling);
    } else {
      atcWrap.parentNode.appendChild(grid);
    }
    return true;
  }

  /* (2026-09-24) Shows the DELIVERY date: #deliveryByDate (ship date + transit, the
     cart's rule, filled by finalproduct-eng.js). It used to mirror #shipByDate and so
     promised delivery on the day the ring ships. International visitors get the
     dispatch date (data-intl="1"), worded as a ship date. Kept invisible (space
     reserved, no layout shift) until the date is in. */
  function buildOrderBy(section){
    if (section.querySelector('.sp-order-by')) return true;
    var dateEl = section.querySelector('#deliveryByDate');
    if (!dateEl) return false;
    var grid = section.querySelector('.sp-secondary-ctas');
    var atcWrap = findAtcWrap(section);
    var anchor = grid || atcWrap;
    if (!anchor) return false;

    var wrap = document.createElement('div');
    wrap.className = 'sp-order-by';
    wrap.innerHTML =
      '<p class="sp-order-by__line"><span data-bind="order-label">Order now for delivery by</span> ' +
      '<strong data-bind="ship-date"></strong></p>';

    if (anchor.nextSibling){
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    } else {
      anchor.parentNode.appendChild(wrap);
    }

    var dateBind = wrap.querySelector('[data-bind="ship-date"]');
    var labelBind = wrap.querySelector('[data-bind="order-label"]');
    function sync(){
      var t = (dateEl.textContent || '').trim();
      var label = dateEl.getAttribute('data-intl') === '1' ? 'Order now to ship by' : 'Order now for delivery by';
      if (labelBind.textContent !== label) labelBind.textContent = label;
      if (dateBind.textContent !== t) dateBind.textContent = t;
      wrap.style.visibility = t ? '' : 'hidden';
    }
    sync();
    /* sync directly, not on requestAnimationFrame: rAF never fires in a background
       tab, which left the line blank until the shopper switched to it */
    new MutationObserver(sync)
      .observe(dateEl, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['data-intl'] });

    return true;
  }

  /* ─── Grand-total computation: setting+diamond + cart refinements ─── */

  function moneyToNumber(s){
    if (!s) return 0;
    var n = parseFloat(String(s).replace(/[^0-9.]/g,''));
    return isNaN(n) ? 0 : n;
  }
  function fmtMoney(n){
    /* Match native price format: $X,XXX.XX */
    return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  var cachedRefinementCents = 0;

  function fetchRefinementCents(){
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var total = 0;
      (cart.items || []).forEach(function(it){
        var p = it.properties || {};
        if (p._extra_type){
          var lp = it.final_line_price != null ? it.final_line_price
                 : (it.line_price != null ? it.line_price
                 : (it.price * (it.quantity || 1)));
          total += lp;
        }
      });
      cachedRefinementCents = total;
      return total;
    })
    .catch(function(){ return cachedRefinementCents; });
  }

  function ensureGrandTotalSpan(priceBlock){
    var span = priceBlock.querySelector('.sp-stp-grand-total');
    if (span) return span;
    span = document.createElement('span');
    span.className = 'sp-stp-grand-total';
    /* Insert before #productprice so it appears in the same visual slot. */
    var native = priceBlock.querySelector('#productprice');
    if (native){
      native.parentNode.insertBefore(span, native);
    } else {
      priceBlock.appendChild(span);
    }
    return span;
  }

  function applyGrandTotal(refinementCents){
    var section = document.getElementById('finalmainsection');
    if (!section) return;
    var priceBlock = section.querySelector('.product-single__price');
    if (!priceBlock) return;
    var native = priceBlock.querySelector('#productprice');
    if (!native) return;

    var basePrice = moneyToNumber(native.textContent);
    var refinements = (refinementCents || 0) / 100;
    var grand = basePrice + refinements;

    if (refinements > 0 && basePrice > 0){
      var span = ensureGrandTotalSpan(priceBlock);
      var nextText = fmtMoney(grand);
      if (span.textContent !== nextText) span.textContent = nextText;
      priceBlock.setAttribute('data-sp-has-refinements', 'true');
    } else {
      priceBlock.setAttribute('data-sp-has-refinements', 'false');
    }
  }

  function recomputeGrand(){
    fetchRefinementCents().then(function(cents){
      applyGrandTotal(cents);
    });
  }

  function watchPriceChanges(section){
    var native = section.querySelector('#productprice');
    if (!native || native.__spGrandObs) return;
    /* Observe native price changes (e.g., variant change, size pick).
       Re-run grand-total apply with the cached refinements — fast,
       no extra fetch on every native blink. */
    var obs = new MutationObserver(function(){
      applyGrandTotal(cachedRefinementCents);
    });
    obs.observe(native, { childList:true, subtree:true, characterData:true });
    native.__spGrandObs = obs;
  }

  function wireGrandTotal(){
    var section = document.getElementById('finalmainsection');
    if (!section) return;
    recomputeGrand();
    watchPriceChanges(section);
    /* React to cart changes — the native code or extras snippet fires
       these when the user adds/removes a refinement. */
    ['cart:updated','cart:refresh','cart:build','refresh:cart','cart.requestRefresh'].forEach(function(n){
      document.addEventListener(n, function(){ setTimeout(recomputeGrand, 60); });
    });
  }

  function tryInit(){
    var section = document.getElementById('finalmainsection');
    if (!section) return false;
    relocatePrice(section);
    var ctasOk  = buildSecondaryCtas(section);
    var orderOk = buildOrderBy(section);
    if (orderOk && ctasOk){
      wireGrandTotal();
      return true;
    }
    return false;
  }

  function bootstrap(){
    if (tryInit()) return;
    var attempts = 0;
    var iv = setInterval(function(){
      attempts++;
      if (tryInit() || attempts > 40){ clearInterval(iv); }
    }, 250);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
